export default {
  docs: {
    documentation: 'Documentation',
    faq: 'FAQ',
    frequentlyAskedQuestions: 'Frequently asked questions',
    tutorials: 'Tutorials',
  },
}
